import React from 'react'; // eslint-disable-line
import { withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { ExpansionPanel } from '../../../../../forms/form-components/expansion-panel/expansion-panel';
import styles, { StyledComponent } from '../../../../../styles/styles';
import { ClaimantsView } from './claimants/claimants-view';
import { DeceasedDetailsView } from './deceased-details/deceased-details-view';
import { DeceasedOccupationView } from './deceased-details/deceased-occupation-view';
import { DeclarationView } from './declaration/declaration-view';
import { FuneralParlourView } from './funeral-parlour/funeral-parlour-view';
import { PolicyOwnerView } from './policy-owner/policy-owner-view';
import { getClaim } from '../../../../../claim';
import { State } from '../../../../../redux/root-reducer';
import { Claim } from '../../../../../claim';

interface StyledProps extends StyledComponent {}

interface BaseProps {
    claim: Claim;
}

type Props = StyledProps & BaseProps;

// eslint-disable-next-line react/prop-types
const formDetailsView: React.FunctionComponent<Props> = ({ claim }) => {
    return (
        <ExpansionPanel
            name="Form Details"
            label={
                <>
                    <span>Form Details</span>
                    {/* eslint-disable-next-line react/prop-types */}
                    {!claim.canShowFormDetails && (
                        <span
                            style={{
                                marginLeft: 8,
                                color: '#161616',
                                fontSize: '0.75rem',
                                fontWeight: 400,
                            }}
                        >
                            (Some fields may appear blank because this claim was submitted using a
                            different form. All details are available in {'Claimant Statement'}.)
                        </span>
                    )}
                </>
            }
        >
            <DeceasedDetailsView />
            <DeceasedOccupationView />
            <PolicyOwnerView />
            <FuneralParlourView />
            <DeclarationView />
            <ClaimantsView />
        </ExpansionPanel>
    );
};

const mapStateToProps = (state: State): BaseProps => ({
    claim: getClaim(state),
});

export const FormDetailsView = connect(mapStateToProps)(withStyles(styles)(formDetailsView));
